// The visitor's size, remembered across product pages (2026-11-02, from Clarity recordings 2f09d987 and
// 749e8b79: visitors picked their size again on every model and opened recommended models that did not
// have it, then went straight back).
//
// 1. Saves the size from a real tap on a size: the product page grid, the phone size sheet, and the
//    "Chybí tvoje velikost?" sheet (localStorage "pk-my-size": { shoe: "42", wear: "M" }).
// 2. Product cards (collections, search, "Mohlo by se ti líbit"; snippets/pk-card-pick.liquid lists the
//    sizes in stock in data-pk-sizes): when the remembered size is in stock, the line under the price
//    says "Tvoje EU 42 skladem". The card does NOT pre-select the size on the product page (2026-11-03,
//    owner: a size chosen weeks ago, or for someone else, must not end up in the cart unnoticed); the
//    product page offers it as one tap instead (snippets/pk-my-size.liquid).
// 3. The size is forgotten 30 days after the last real tap on a size.
// The product page row "Tvoje velikost EU 42 je skladem" is snippets/pk-my-size.liquid.
(function () {
  if (window.pkMySize) return;
  var KEY = 'pk-my-size';
  var MAX_AGE = 30 * 24 * 60 * 60 * 1000;

  function norm(size) {
    return String(size || '').trim().replace(',', '.');
  }

  function read() {
    try {
      var saved = JSON.parse(localStorage.getItem(KEY) || 'null') || {};
      // Saved before the expiry existed: start the 30 days now
      if (!saved.ts && (saved.shoe || saved.wear)) {
        saved.ts = Date.now();
        localStorage.setItem(KEY, JSON.stringify(saved));
      }
      if (saved.ts && Date.now() - saved.ts > MAX_AGE) {
        localStorage.removeItem(KEY);
        return {};
      }
      return saved;
    } catch (_) {
      return {};
    }
  }

  function save(size) {
    size = norm(size);
    if (!size || size.length > 12 || /default/i.test(size)) return;
    var saved = read();
    var kind = /^\d/.test(size) ? 'shoe' : 'wear';
    var same = saved[kind] === size;
    saved[kind] = size;
    saved.ts = Date.now();
    try {
      localStorage.setItem(KEY, JSON.stringify(saved));
    } catch (_) {
      return;
    }
    if (!same) annotateAll(true);
  }

  // Only real taps count: the shop's own scripts click sizes too (the sheets, the only size in stock)
  document.addEventListener(
    'click',
    function (event) {
      if (!event.isTrusted || !event.target.closest) return;
      var tile = event.target.closest('[data-variant-container] [data-variant-id], .size-sheet__size[data-variant-id], .pk-alts__size[data-size]');
      if (!tile) return;
      if (tile.dataset.size) return save(tile.dataset.size);
      var main = document.querySelector('[data-variant-container] [data-variant-id="' + tile.dataset.variantId + '"]');
      if (main) save(main.dataset.variantTitle);
    },
    true
  );

  function cardText(size) {
    var label = /^\d/.test(size) ? 'EU ' + size : size;
    return ((window.pkT && window.pkT.myCard) || 'Tvoje [size] skladem').split('[size]').join(label);
  }


  function annotate(price, saved) {
    var meta = price.querySelector('.pk-cp__meta');
    if (!meta) return;
    if (meta.dataset.pkText == null) meta.dataset.pkText = meta.textContent;
    var pairs = price.dataset.pkSizes.split('|');
    var first = norm(pairs[0].slice(0, pairs[0].lastIndexOf(':')));
    var size = saved[/^\d/.test(first) ? 'shoe' : 'wear'];
    var id = '';
    if (size) {
      for (var i = 0; i < pairs.length; i++) {
        var cut = pairs[i].lastIndexOf(':');
        if (norm(pairs[i].slice(0, cut)) === size) {
          id = pairs[i].slice(cut + 1);
          break;
        }
      }
    }
    meta.textContent = id ? cardText(size) : meta.dataset.pkText;
    meta.classList.toggle('pk-cp__meta--ok', !!id);
    price.dataset.pkMine = id ? '1' : '0';
  }

  function annotateAll(again) {
    var saved = read();
    if (!saved.shoe && !saved.wear) return;
    var prices = document.querySelectorAll(again ? '.pk-cp[data-pk-sizes]' : '.pk-cp[data-pk-sizes]:not([data-pk-mine])');
    for (var i = 0; i < prices.length; i++) annotate(prices[i], saved);
  }

  // Cards that arrive later: recommendations, "Načíst další", filters, predictive search
  var queued = false;
  new MutationObserver(function (records) {
    if (queued) return;
    var added = false;
    for (var r = 0; r < records.length && !added; r++) if (records[r].addedNodes.length) added = true;
    if (!added) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      annotateAll(false);
    });
  }).observe(document.body, { childList: true, subtree: true });

  annotateAll(false);
  window.pkMySize = { read: read, save: save };
})();
